import React, { FC } from "react";
import {
  CardContainer,
  ColumnsByBreakpoint,
} from "@ldp-web/component-library/ui/organisms/card-container";
import { HeaderGroupComponent } from "../header-group";
import { MiniInfoCard } from "@ldp-web/component-library/ui/molecules/mini-info-card";
import { MiniInforCardProps } from "./mini-info-card-container.component.interface";
import {
  IComponentCommonProps,
  IHeaderGroupComponentProps,
} from "@ldp/common-types";
import { WrapperComponent } from "../wrapper";

export type UpNumber = "1UP" | "3UP" | "4UP";
export type ContainerType =
  | "GRID"
  | "SCROLLER"
  | "GRID_WITH_SCROLLER_ON_SMALL_SCREENS";

/** Don't forget to add prop types */
export interface CardContainerComponentProps extends IComponentCommonProps {
  headerGroup?: IHeaderGroupComponentProps;
  containerType: ContainerType;
  upNumber: UpNumber;
  miniInfoCards: MiniInforCardProps[];
  /** id of component */
  id?: string;
}

/** TBD: What is the purpose of this component? */
export const MiniInfoCardContainerComponent = ({
  headerGroup,
  containerType,
  upNumber,
  miniInfoCards,
  styling,
  id,
}: CardContainerComponentProps) => {
  const columnLayout: Record<
    ContainerType,
    Record<UpNumber, ColumnsByBreakpoint>
  > = {
    GRID: {
      "1UP": {
        mobile: 1,
        tablet: 1,
        tabletLarge: 1,
        desktop: 1,
      },
      "3UP": {
        mobile: 2,
        tablet: 3,
        tabletLarge: 3,
        desktop: 3,
      },
      "4UP": {
        mobile: 2,
        tablet: 2,
        tabletLarge: 4,
        desktop: 4,
      },
    },
    SCROLLER: {
      "1UP": {
        mobile: 1,
        tablet: 1,
        tabletLarge: 1,
        desktop: 1,
      },
      "3UP": {
        mobile: 2,
        tablet: 3,
        tabletLarge: 3,
        desktop: 3,
      },
      "4UP": {
        mobile: 2,
        tablet: 3,
        tabletLarge: 4,
        desktop: 4,
      },
    },
    GRID_WITH_SCROLLER_ON_SMALL_SCREENS: {
      "1UP": {
        mobile: 1,
        tablet: 1,
        tabletLarge: 1,
        desktop: 1,
      },
      "3UP": {
        mobile: 2,
        tablet: 3,
        tabletLarge: 3,
        desktop: 3,
      },
      "4UP": {
        mobile: 2,
        tablet: 3,
        tabletLarge: 4,
        desktop: 4,
      },
    },
  };

  return (
    <WrapperComponent styling={styling} id={id}>
      {headerGroup && <HeaderGroupComponent noWrapper {...headerGroup} />}
      <CardContainer
        columnLayout={columnLayout[containerType][upNumber]}
        variant={containerType}
        cards={miniInfoCards.map((cardProps) => (
          <MiniInfoCard
            key={cardProps.headline}
            headline={cardProps.headline}
            displayText={cardProps.displayText1}
            imageAltText={cardProps.image?.altText}
            imageUrl={cardProps.image?.url}
            minW="initial"
          />
        ))}
      />
    </WrapperComponent>
  );
};

export default MiniInfoCardContainerComponent;
